export class StoreCategory {
    constructor(
        public StoreCategoryId:number=0,
        public StoreCategoryName:string=""
    )
    {

    }
}
